const messages = {
  // Regist
  'Registered Email': '既に登録されているメールアドレスです',
  'Failed Add Auth0 Data': '既に承認されているメールアドレスです',
  'Incorrect Access': '不正なアクセスです',
  'Incorrect Parameters': '不正な操作です',
  // Verify
  'Not Found Code': '確認コードが見つかりません',
  'Verification Expired': 'メールアドレスの検証有効期限切れです',
  // Exists
  'Empty Directory': 'ディレクトリを指定してください',
  'Registered Directory': '既に登録されているディレクトリです',
  // Initial
  'Incorrect Directory': 'ディレクトリが正しくありません',
  'Incorrect Name': '会社名が正しくありません',
  'Incorrect Headcount': 'が正しくありません',
  'Incorrect FoundationDate': '設立年月日が正しくありません',
  'Incorrect Segment': '業界が正しくありません',
  'Incorrect President': '代表者名が正しくありません',
  'Incorrect Url': 'URLが正しくありません',
  'Incorrect Tel': '電話番号が正しくありません',
  'Incorrect Zip': '郵便番号が正しくありません',
  'Incorrect Prefecture': '都道府県が正しくありません',
  'Incorrect Locality': '市区町村・番地が正しくありません',
  'Incorrect Building': 'ビル・マンション名が正しくありません'
}

export default {
  methods: {
    handleLink (path) {
      this.$router.push(path, () => {}, () => {})
    },
    msgBoxConfirm (message, cb1, cb2) {
      this.$bvModal.msgBoxConfirm(message, {
        okTitle: 'はい',
        cancelTitle: 'いいえ'
      }).then((val) => {
        if (val) {
          if (cb1) {
            cb1()
          }
        } else {
          if (cb2) {
            cb2()
          }
        }
      })
    },
    msgBoxError (orgMessage, cb) {
      let message = messages[orgMessage] ? messages[orgMessage] : orgMessage
      this.$bvModal.msgBoxOk(message, {
        okTitle: '閉じる'
      }).then(() => {
        if (cb) {
          cb()
        }
      })
    }
  }
}
